import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { listNumbers } from '@teqplay/viewer'

import {
  getAllLoadstationsAtQuays,
  getLoadstationsBetweenBollards,
  getAllQuayLoadstations
} from '../../../../utils/general'

export default class BollardLoadStations extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      loadStationDetails: null,
      loadStationDetailsStartBollard: null,
      loadStationDetailsEndBollard: null
    }
  }

  static propTypes = {
    bollardToScreen: PropTypes.func.isRequired,
    quays: PropTypes.array.isRequired
  }

  render() {
    const preprocessedLoadStations = [].concat(
      ...this.props.quays.map(quay => {
        // create loadStations
        const loadStations = this.getQuayLoadstations(quay)

        if (!quay.quayType || quay.quayType === 'BOLLARD') {
          return this.preprocessBollardLoadStations(loadStations, this.props.bollardToScreen)
        } else {
          return this.preprocessStickyLoadStations(quay, loadStations, this.props.bollardToScreen)
        }
      })
    )

    const height = preprocessedLoadStations.length
      ? Math.max(...preprocessedLoadStations.map(item => bottom(item.style)))
      : 0
    const style = {
      height
    }

    const bollards = listNumbers(
      this.props.quays[0].minBollard,
      this.props.quays[this.props.quays.length - 1].maxBollard
    )

    const loadStations = getAllLoadstationsAtQuays(this.props.quays)

    return (
      <div className="load-stations-wrapper">
        <div className="load-stations" style={style}>
          {preprocessedLoadStations.map((item, index) => (
            <div key={index} className="load-station" style={item.style}>
              {item.hasUnloading ? <i className={'fa fa-arrow-circle-up cargo-type-indicator'} /> : null}
              {item.hasLoading ? <i className={'fa fa-arrow-circle-down cargo-type-indicator'} /> : null}
              {item.title}
            </div>
          ))}
        </div>
        <div className="information-trigger-wrapper">
          {bollards.map((bollard, index) => {
            const left = this.props.bollardToScreen(bollard)
            const right = this.props.bollardToScreen(bollard + 1)
            const width = right - left + 1

            const currentQuay = this.props.quays.find(
              quay => bollard >= quay.minBollard && bollard + 1 <= quay.maxBollard
            )

            if (currentQuay) {
              if (!currentQuay.quayType || currentQuay.quayType === 'BOLLARD') {
                // Get products between the current bollard and next bollard
                const loadStationsBetweenBollards = getLoadstationsBetweenBollards(loadStations, bollard, bollard + 1)

                return (
                  <div
                    key={index}
                    style={{ left, width }}
                    className={`information-trigger ${
                      this.state.loadStationDetailsStartBollard === bollard ? 'selected' : ''
                    }`}
                    onClick={() =>
                      this.setState(({ loadStationDetailsStartBollard }) => {
                        if (loadStationDetailsStartBollard === bollard) {
                          return {
                            loadStationDetails: null,
                            loadStationDetailsStartBollard: null,
                            loadStationDetailsEndBollard: null
                          }
                        } else {
                          return {
                            loadStationDetails: loadStationsBetweenBollards,
                            loadStationDetailsStartBollard: bollard,
                            loadStationDetailsEndBollard: bollard + 1
                          }
                        }
                      })
                    }
                  />
                )
              }
            }

            return null
          })}

          {this.props.quays
            .filter(quay => quay.quayType === 'STICKY')
            .map((quay, index) => {
              const left = this.props.bollardToScreen(quay.minBollard)
              const right = this.props.bollardToScreen(quay.maxBollard)
              const width = right - left + 1

              const quayLoadStations = getAllQuayLoadstations(quay)

              return (
                <div
                  key={index}
                  style={{ left, width }}
                  className="information-trigger"
                  onMouseOver={() =>
                    this.setState({
                      loadStationDetails: quayLoadStations,
                      loadStationDetailsStartBollard: quay.minBollard,
                      loadStationDetailsEndBollard: quay.maxBollard
                    })
                  }
                  onMouseOut={() =>
                    this.setState({
                      loadStationDetails: null,
                      loadStationDetailsStartBollard: null,
                      loadStationDetailsEndBollard: null
                    })
                  }
                />
              )
            })}
        </div>

        {this.renderLoadStationInformation(
          this.state.loadStationDetails,
          this.state.loadStationDetailsStartBollard,
          this.state.loadStationDetailsEndBollard,
          this.props.bollardToScreen
        )}
      </div>
    )
  }

  getQuayLoadstations = quay => {
    const jetties = quay.jetties ? quay.jetties : []
    const mobrus = quay.mobrus ? quay.mobrus : []

    // create loadStations
    return [...mobrus, ...jetties]
  }

  preprocessBollardLoadStations(loadStations, bollardToScreen) {
    const preprocessedLoadStations = []

    loadStations.forEach(loadStation => {
      const bollardStart =
        typeof loadStation.bollardStart === 'number' ? loadStation.bollardStart : loadStation.bollard - 0.5
      const bollardEnd = loadStation.bollardEnd ? loadStation.bollardEnd : bollardStart + 1

      const left = bollardToScreen(bollardStart) || 0
      const right = bollardToScreen(bollardEnd) || 0
      const width = right - left + 1 // the plus one is to have the load station border overlap with the grid axis on its right
      const top = 0
      const height = 20

      const newItem = {
        loadStation,
        title: loadStation.bollardEnd ? loadStation.name : '',
        hasUnloading:
          loadStation.products && loadStation.products.find(p => p.operation === 'unloading') ? true : false,
        hasLoading: loadStation.products && loadStation.products.find(p => p.operation === 'loading') ? true : false,
        style: {
          top,
          left,
          width,
          height,
          background: loadStation.color,
          boxSizing: 'border-box'
        }
      }

      // find a vertical position not overlapping with previous load stations
      while (preprocessedLoadStations.some(item => isOverlapping(item.style, newItem.style))) {
        newItem.style.top += 24
      }

      preprocessedLoadStations.push(newItem)
    })

    return preprocessedLoadStations
  }

  preprocessStickyLoadStations(quay, loadStations, bollardToScreen) {
    const preprocessStickyLoadStations = []

    const left = bollardToScreen(quay.minBollard)
    const right = bollardToScreen(quay.maxBollard)
    const width = right - left
    const top = 0
    const height = 20

    loadStations.forEach(loadStation => {
      const newItem = {
        loadStation,
        title: loadStation.name,
        hasUnloading:
          loadStation.products && loadStation.products.find(p => p.operation === 'unloading') ? true : false,
        hasLoading: loadStation.products && loadStation.products.find(p => p.operation === 'loading') ? true : false,
        style: {
          top,
          left,
          width,
          height,
          background: loadStation.color,
          boxSizing: 'border-box'
        }
      }

      // find a vertical position not overlapping with previous load stations
      while (preprocessStickyLoadStations.some(item => isOverlapping(item.style, newItem.style))) {
        newItem.style.top += 24
      }

      preprocessStickyLoadStations.push(newItem)
    })

    return preprocessStickyLoadStations
  }

  renderLoadStationInformation = (loadstations, startBollard, endBollard, bollardToScreen) => {
    if (loadstations && loadstations.length) {
      const availableAt = loadstation => {
        return loadstation.bollard === startBollard ? 'start' : loadstation.bollard === endBollard ? 'end' : 'between'
      }

      const loadStationsAtStartBollard = loadstations.filter(l => availableAt(l) === 'start')
      const loadStationsAtEndBollard = loadstations.filter(l => availableAt(l) === 'end')
      const loadStationsBetweenBollards = loadstations.filter(l => availableAt(l) === 'between')

      const modalWidth = 350
      let marginLeftModal = modalWidth / 2

      const currentPosition = bollardToScreen(startBollard + (endBollard - startBollard) / 2)

      // figure out what the margin left will be
      if (marginLeftModal > currentPosition) {
        marginLeftModal = currentPosition + 1
      } else {
        const maxBollardScreenPos = bollardToScreen(this.props.quays[this.props.quays.length - 1].maxBollard + 0.5)

        const spaceLeftOver = maxBollardScreenPos - currentPosition

        if (marginLeftModal > spaceLeftOver) {
          marginLeftModal = marginLeftModal * 2 - 9 - spaceLeftOver
        }
      }

      // Style modal itself
      const modalStyle = {
        left: currentPosition,
        width: modalWidth,
        marginLeft: -marginLeftModal
      }

      // Style top arrow
      const arrowStyle = {
        left: currentPosition,
        marginLeft: -9
      }

      return (
        <div className="selected-bollard-modal-wrapper">
          <div className="arrow-top" style={arrowStyle} />

          <div className="selected-bollard-modal" style={modalStyle}>
            <div className="loadstations-wrapper">
              {loadStationsAtStartBollard.length
                ? this.renderLoadStationInformationSection(
                    `LoadStations available at bollard ${startBollard}`,
                    loadStationsAtStartBollard
                  )
                : null}

              {loadStationsBetweenBollards.length
                ? this.renderLoadStationInformationSection(
                    `Products available in between bollards ${startBollard} and ${endBollard}`,
                    loadStationsBetweenBollards
                  )
                : null}

              {loadStationsAtEndBollard.length
                ? this.renderLoadStationInformationSection(
                    `Products available at bollard ${endBollard}`,
                    loadStationsAtEndBollard
                  )
                : null}
            </div>
          </div>
        </div>
      )
    }

    return null
  }

  renderLoadStationInformationSection = (title, loadStations) => {
    return (
      <div>
        <span className="header">{title}</span>
        {loadStations.map((loadStation, index) => {
          return (
            <ul className="loadstation-container" key={index}>
              <li className={'fa fa-square cargo-type-indicator'} style={{ color: loadStation.color }}>
                <span className="loadstation-name">{loadStation.name} products</span>
              </li>
              <li>
                <ul className="products-container">
                  {loadStation.products &&
                    loadStation.products.map((product, productIndex) => {
                      return (
                        <li
                          key={loadStation.name + index + productIndex + product.product}
                          className={`fa ${
                            product.isUnloading ? 'fa-arrow-circle-up' : 'fa-arrow-circle-down'
                          } cargo-type-indicator`}
                          style={{ color: product.color }}
                        >
                          <span className="product-name">{product.product}</span>
                        </li>
                      )
                    })}
                </ul>
              </li>
            </ul>
          )
        })}
      </div>
    )
  }
}

function isOverlapping(a, b) {
  return a.left < right(b) && right(a) > b.left && bottom(a) > b.top && a.top < bottom(b)
}

function bottom(a) {
  return a.top + a.height
}

function right(a) {
  return a.left + a.width
}
